import { VehicleTypeEnum } from '@/services/api-clients';
import i18n from '@/i18n/config';
import { LF } from '@/i18n/LF';

export function vehicleTypeFilter(vehicleType: VehicleTypeEnum) {
  switch (vehicleType) {
    case VehicleTypeEnum.Bike: return i18n.t(LF.Bike) as string;
    case VehicleTypeEnum.ElectricBike: return i18n.t(LF.EBike) as string;
    case VehicleTypeEnum.Motor: return i18n.t(LF.MotorScooter) as string;
    case VehicleTypeEnum.Car: return i18n.t(LF.Car) as string;
    default: return '';
  }
}
